export const unreadMessagesCount = state => state.messages.main.length
export const notifications = state => state.notifications.main
export const unreadNotificationsCount = state => state.notifications.main.filter(item => item.unread).length
export const remainTasksCount = state => state.tasks.main.length
export const currentUser = state => state.user.main
export const menu = state => state.menu.main
export const userInfo = state => state.user.main.user_info
export const editPermission = state => state.user.main.edit_permissions
export const softphone = state => state.softphone.main
export const initOrderDetailId = state => state.payments.main



// WEBPACK FOOTER //
// ./src/vuex/getters.js